<mat-card>
    <mat-card-title>Sender Information</mat-card-title>
    <div class="sender-information-inputs" (keyup.enter)="submitForm()">
        <div class="form-field">
            <mat-form-field>
                <input
                    matInput
                    maxlength="20"
                    placeholder="Sender First Name"
                    formControlName="senderFirstName"
                />
                <mat-error *ngIf="senderFirstName.errors?.required">
                    Sender first name is required
                </mat-error>
            </mat-form-field>
        </div>

        <div class="form-field">
            <mat-form-field>
                <input
                    matInput
                    maxlength="20"
                    placeholder="Sender Last Name"
                    formControlName="senderLastName"
                />
            </mat-form-field>
        </div>

        <div class="form-field">
            <mat-form-field>
                <input
                    matInput
                    maxlength="60"
                    placeholder="Sender Email"
                    formControlName="senderEmail"
                />
                <mat-error *ngIf="senderEmail.errors?.required">
                    Sender email is required</mat-error
                >
                <mat-error *ngIf="!senderEmail.errors?.required">
                    Sender email is invalid</mat-error
                >
            </mat-form-field>
        </div>
    </div>
</mat-card>
